import { useState } from "react";

import ImageLink from "components/common/Links/ImageLink/ImageLink";
import { FACEBOOK, INSTAGRAM, LocaleKey } from "constants/socialMediaURLs";
import FacebookIcon from "static/icons/facebook.svg";
import FacebookHoverIcon from "static/icons/facebook_hover.svg";
import InstagramIcon from "static/icons/instagram.svg";
import InstagramHoverIcon from "static/icons/instagram_hover.svg";
import classes from "./SocialNetworksSection.module.css";
import { useRouter } from "next/router";

const SocialNetworksSection = () => {
  const { locale } = useRouter();

  const [facebookIconHover, setFacebookIconHover] = useState(false);
  const [instagramIconHover, setInstagramIconHover] = useState(false);

  return (
    <div className={classes.socialNetworksSection}>
      <div>
        <span
          onMouseEnter={() => setFacebookIconHover(true)}
          onMouseLeave={() => setFacebookIconHover(false)}
        >
          <ImageLink
            href={FACEBOOK[locale as LocaleKey] || "/"}
            src={facebookIconHover ? FacebookHoverIcon : FacebookIcon}
            alt="Facebook"
            openInNewTab
          />
        </span>
        <span
          onMouseEnter={() => setInstagramIconHover(true)}
          onMouseLeave={() => setInstagramIconHover(false)}
        >
          <ImageLink
            href={INSTAGRAM[locale as LocaleKey] || "/"}
            src={instagramIconHover ? InstagramHoverIcon : InstagramIcon}
            alt="Instagram"
            openInNewTab
          />
        </span>
      </div>
    </div>
  );
};

export default SocialNetworksSection;
